import { render } from "./YandexSmartCaptcha.vue?vue&type=template&id=6aa05ab8&scoped=true"
import script from "./YandexSmartCaptcha.vue?vue&type=script&lang=js"
export * from "./YandexSmartCaptcha.vue?vue&type=script&lang=js"

import "./YandexSmartCaptcha.vue?vue&type=style&index=0&id=6aa05ab8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa05ab8"]])

export default __exports__